import { render, staticRenderFns } from "./oddsChangesSettings.vue?vue&type=template&id=fac72c72&scoped=true"
import script from "./oddsChangesSettings.vue?vue&type=script&lang=js"
export * from "./oddsChangesSettings.vue?vue&type=script&lang=js"
import style0 from "./oddsChangesSettings.vue?vue&type=style&index=0&id=fac72c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac72c72",
  null
  
)

export default component.exports